import { render, staticRenderFns } from "./UpsellItems.vue?vue&type=template&id=97a0c266&scoped=true"
import script from "./UpsellItems.vue?vue&type=script&lang=js"
export * from "./UpsellItems.vue?vue&type=script&lang=js"
import style0 from "./UpsellItems.vue?vue&type=style&index=0&id=97a0c266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a0c266",
  null
  
)

export default component.exports